// extracted by mini-css-extract-plugin
module.exports = {"confirmedLabel":"ConfirmedOptionRenderer__confirmedLabel--1LJ4j"};